import { useMutation } from 'react-query';
import { forgotPass, getExClientLogin, getToken } from './tokens';
import { setAccessToken } from '../axios';

export function useLoginMutation({
  integratedLogin,
  agreementId,
  onSuccess,
  onError,
}: {
  integratedLogin?: string;
  agreementId?: number;
  onSuccess: () => void;
  onError: (error: string) => void;
}) {
  return useMutation(
    ({ username, password, idp }: { username: string; password?: string; idp?: string }) =>
      getToken({ username, password, idp, integratedLogin, agreement_id: agreementId }),
    {
      onSuccess: function (data) {
        setAccessToken(data.token, data.tokenExpirationDate);
        onSuccess();
      },
      onError: function (error: Record<string, unknown>) {
        const response = error.response as { data: { error?: string } };
        if (response.data.error) {
          onError(response.data.error);
        } else {
          onError('Erro ao fazer login');
        }
      },
    }
  );
}

export function useLoginExClient({ onSuccess, onError }: { onSuccess: () => void; onError: (error: string) => void }) {
  return useMutation(({ cpf }: { cpf: string }) => getExClientLogin({ cpf }), {
    onSuccess: function (data) {
      setAccessToken(data.token);
      onSuccess();
    },
    onError: function (error: Record<string, unknown>) {
      const response = error.response as { data: { error?: string } };
      if (response.data.error) {
        onError(response.data.error);
      } else {
        onError(JSON.stringify(response.data));
      }
    },
  });
}

export function useRecoveryMutation({
  onSuccess,
  onError,
}: {
  agreementId?: number;
  onSuccess: () => void;
  onError: (error: string) => void;
}) {
  return useMutation(({ email }: { email: string }) => forgotPass({ email }), {
    onSuccess: function () {
      onSuccess();
    },
    onError: function (error: Record<string, unknown>) {
      onError((error.response as Record<string, Record<string, string>>).data.error as string);
    },
  });
}
